import React from "react";
import { motion } from "framer-motion";

// Reveal a block by fading + translating up
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.2 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

// Split a headline into words and reveal each with a mask
export const MaskedLines = ({ lines = [], className = "", delayStart = 0.1, stagger = 0.12 }) => {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask block">
          <motion.span
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: delayStart + i * stagger, ease: [0.16, 1, 0.3, 1] }}
            className="block"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1.2, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
